<h1 class="page-title mb-5">دليل المستثمر</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div class="investor-guide-content">
          <h2 class="main-heading mb-4">للحصول على التفاصيل</h2>

          <div class="guide-section">
            <h3 class="section-title">
              <span class="title-text">دليل المستثمر:</span>
              <a href="../../../assets/دليل المستثمر ISC.pdf" class="click-here-link">اضغط هنا</a>
            </h3>

            <ul class="file-list">
              <li class="file-item">
                <a href="../../../assets/دليل المستثمر لخدمات المناطق الحرة.pdf" class="file-link">
                  <i class="fa-solid fa-file-pdf file-icon"></i>
                  <span class="file-name">دليل المستثمر لخدمات المناطق الحرة.</span>
                </a>
              </li>
              <li class="file-item">
                <a href="../../../assets/الترجمة الصينية لدليل المستثمر.pdf" class="file-link">
                  <i class="fa-solid fa-file-pdf file-icon"></i>
                  <span class="file-name">دليل المستثمر باللغة الصينية</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <app-fixed-go-on></app-fixed-go-on>
      </div>
    </div>
  </div>
</div>